export default __webpack_public_path__ + "static/media/EntrataAbruzzo.9bf9af89.avif";